export default "/images/remove.png?d93067c2bb07624239ab66c3f8381579";